const moment = require('moment-timezone');

export const setUser = val => {
  return async dispatch => {
    dispatch(setReduxUser(val));
    let res;

    //Get User data from db
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(val)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_USER" }) }

    console.log(res);
    localStorage.setItem('token', res.token)
    dispatch(setReduxUserDBInfo(res._doc));

    //Get Chart data
    try {
      const userMail = val.email;
      const currentYear = moment().tz('Africa/Accra').format("YYYY");
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/chart/${userMail}/${currentYear}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_USER" }) }

    console.log(res);
    dispatch(setReduxUserChartInfo(res));

    //Get Sweep info
    try {
      const userMail = val.email;
      console.log('set_user trying....', userMail);
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/sweep/${userMail}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        }
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_USER" }) }

    console.log('SWEEP', res);
    dispatch(setReduxUserSweepInfo(res));
  };
};

export const updateUser = val => {
  console.log(val);
  let imageName = '';
  if (val.imageURL) {
    imageName = val.imageURL.replace('https://miso-app.s3.eu-west-2.amazonaws.com/', '')
  }
  const data = { ...val, imageName };
  return async dispatch => {
    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/users`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(data)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_USER" }) }

    console.log(res);
    window.location.reload();
  };
};

export const requestSweep = val => {
  console.log(val);
  return async dispatch => {
    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/sweep`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(val)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_USER" }) }

    console.log(res);
  };
};

export const setReduxUser = val => {
  return { type: "SET_USER", value: val };
};

export const setReduxUserDBInfo = val => {
  return { type: "SET_USER_DB_INFO", value: val };
};

export const setReduxUserChartInfo = val => {
  return { type: "SET_USER_CHART_INFO", value: val };
};

export const setReduxUserSweepInfo = val => {
  return { type: "SET_USER_SWEEP_INFO", value: val };
};